var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ChevronRightIcon } from '@heroicons/react/solid';
import { Avatar } from '../../..';
import { classNames, renderIcon, RoundIcon, } from '../../../..';
import * as stackedListStyles from '../../stacked-list.styles';
import * as styles from './menu-list-item.styles';
export var MenuListItem = function (_a) {
    var item = _a.item, onClickItem = _a.onClickItem;
    var handleClick = function () {
        var _a, _b;
        (_b = (_a = item.onActionClick) === null || _a === void 0 ? void 0 : _a.call(item)) !== null && _b !== void 0 ? _b : onClickItem === null || onClickItem === void 0 ? void 0 : onClickItem(item);
    };
    var backgroundClass = item.hexBackgroundColor
        ? undefined
        : item.backgroundColor
            ? "bg-".concat(item.backgroundColor)
            : 'bg-uiBg';
    var renderLeftIcon = function () {
        var _a;
        if (item.customIcon)
            return item.customIcon;
        if (!item.showIcon && (item === null || item === void 0 ? void 0 : item.menuIconUrl)) {
            return (_jsx(Avatar, { className: "mr-4", displayBorder: true, dataUrl: (_a = item.menuIconUrl) !== null && _a !== void 0 ? _a : '', size: "lg", borderColor: "primary" }));
        }
        if (item.svgIcon || item.menuIconUrl || item.menuIcon) {
            return (_jsx(RoundIcon, { className: "mr-4", svgIcon: item.svgIcon, imageUrl: item.menuIconUrl, icon: item.menuIcon, hexBackgroundColor: item.iconHexBackgroundColor, iconColor: item.iconColor, backgroundColor: item.iconBackgroundColor, iconClassName: item.menuIconClassName }));
        }
        return null;
    };
    return (_jsx("div", __assign({ id: item === null || item === void 0 ? void 0 : item.id, className: classNames(styles.menulistItemContainer, item.className), onClick: handleClick }, { children: _jsxs("div", __assign({ className: item.childList
                ? styles.contentWrapperChildList
                : classNames(styles.contentWrapper, backgroundClass), style: item.hexBackgroundColor
                ? { background: item.hexBackgroundColor }
                : undefined }, { children: [_jsxs("div", __assign({ className: stackedListStyles.textRowsWrapper }, { children: [renderLeftIcon(), _jsx("div", __assign({ className: stackedListStyles.paragraphWrapper }, { children: _jsxs("div", { children: [_jsx("p", __assign({ className: classNames(styles.menuTitle, item.titleStyle) }, { children: item.title })), typeof item.subTitle === 'string' ? (_jsx("p", __assign({ className: classNames(styles.menuSubTitle, item.subTitleStyle) }, { children: _jsx("span", { children: item.subTitle }) }))) : (item.subTitle)] }) }))] })), _jsxs("div", __assign({ className: "flex items-center" }, { children: [item.subItem && (_jsx("p", __assign({ className: classNames(styles.menuSubItem, item.titleStyle) }, { children: item.subItem }))), item.likesItem && _jsx("div", { children: item.likesItem }), item.rightIcon ? (renderIcon(item.rightIcon, item.rightIconClassName)) : !item.hideRightIcon ? (_jsx(ChevronRightIcon, { className: styles.menuChevron })) : null] }))] })) })));
};
export default MenuListItem;
//# sourceMappingURL=menu-list-item.js.map